"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Box = require("../Box/Box");

var _Line = require("../Line/Line");

var _Header = require("../Header/Header");

var _Text = require("../Text/Text");

var _StarRating = require("../StarRating/StarRating");

var _Row = require("../Row/Row");

var _Column = require("../Column/Column");

var _ReviewsRatingBar = require("./ReviewsRatingBar");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
} // Component


var ReviewsSingleGentux =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReviewsSingleGentux, _PureComponent);

  function ReviewsSingleGentux() {
    var _this;

    _classCallCheck(this, ReviewsSingleGentux);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReviewsSingleGentux).call(this));
    _this.getCustomField = _this.getCustomField.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ReviewsSingleGentux, [{
    key: "getCustomField",
    value: function getCustomField(fieldTitle) {
      return this.props.review.customFields.find(function (c) {
        return c.title === fieldTitle;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          review = _this$props.review,
          isLastElement = _this$props.isLastElement,
          customFields = _this$props.customFields;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Row.Row, {
        full: true,
        mb: 4
      }, customFields && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Column.Column, {
        columnSm: 4,
        columnMd: 3,
        mb: [4, 4, 0, 0, 0, 0]
      }, _react.default.createElement(_Box.Box, {
        mb: 3
      }, _react.default.createElement(_StarRating.StarRating, {
        rating: review.score
      })), customFields.map(function (_ref) {
        var key = _ref.key,
            name = _ref.name;
        return _react.default.createElement(_Box.Box, {
          mb: 3,
          key: key
        }, _react.default.createElement(_Header.Header, {
          type: 5,
          mb: 1,
          textColor: "muted"
        }, name), _this2.getCustomField(key) && _react.default.createElement(_ReviewsRatingBar.ReviewsRatingBar, {
          total: 5,
          rating: _this2.getCustomField(key).value
        }));
      }))), _react.default.createElement(_Column.Column, {
        columnSm: customFields ? 8 : 12,
        columnMd: customFields ? 9 : undefined
      }, !customFields && _react.default.createElement(_Box.Box, {
        mb: 2
      }, _react.default.createElement(_StarRating.StarRating, {
        rating: review.score
      })), _react.default.createElement(_Header.Header, {
        type: 4
      }, " ", review.reviewer, " "), _react.default.createElement(_Text.Text, {
        small: true,
        textColor: "muted",
        mb: 3
      }, new Date(parseInt(review.createdAt, 10)).toDateString()), _react.default.createElement(_Text.Text, {
        textColor: "muted"
      }, review.content))), !isLastElement && _react.default.createElement(_Box.Box, {
        pb: 4
      }, _react.default.createElement(_Line.Line, {
        lineColor: "gray"
      })));
    }
  }]);

  return ReviewsSingleGentux;
}(_react.PureComponent); // Prop Types


ReviewsSingleGentux.propTypes = {
  review: _propTypes.default.object.isRequired,
  isLastElement: _propTypes.default.bool
};
ReviewsSingleGentux.defaultProps = {
  isLastElement: false
};

var _default = (0, _styledComponents.withTheme)(ReviewsSingleGentux);

exports.default = _default;